import getToken from '../account/getToken'
import {deleteFundNews} from '../../api/fundNews'

export default store => async item => {
  const {fundNews} = store.getState()
  const token = await getToken(store)()

  store.setState({
    isHydratingFundNews: true,
  })

  if (!token) return

  return deleteFundNews({
    token,
    item,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(response => {
      const remainingItems = fundNews.filter(
        ({_id}) => !response.documentIds.includes(_id),
      )
      store.setState({
        fundNews: remainingItems,
        isHydratingFundNews: false,
      })
    })
    .catch(error => {
      store.setState({
        isHydratingFundNews: false,
      })
    })
}
